import _sfc_main from './src/badge.vue2.mjs';
export { badgeProps } from './src/badge.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElBadge = withInstall(_sfc_main);

export { ElBadge, ElBadge as default };
//# sourceMappingURL=index.mjs.map
